import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from '@redux-devtools/extension';

import { isDev } from 'services/env-service';

import appReducer from './reducers';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];
const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE' || action.type === 'LOGOUT') {
        state = undefined;
    }

    return appReducer(state, action);
}
const composeEnhancers = isDev() ? composeWithDevTools({}) : compose;

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(...middleware)
));

sagaMiddleware.run(rootSaga);

export default store;
